import React from 'react'
import { logo_asamla, } from "../assets/img/index.js";


const TitleSection = () => {
    return (
        <>
            <h1 className="text-xl lg:text-3xl font-thin mb-6 text-[rgb(var(--color-text-main))] leading-tight">
                Les Saynètes&nbsp;|&nbsp;
                <span className="font-extrabold">
                    le diabète
                </span>
            </h1>
        </>

    )
}

export default TitleSection